export default "__VITE_ASSET__RMxGoJ2Q__"